module.exports = __webpack_public_path__ + "img/7_lead_strategist.53dea6e0.png";